import React, { Component } from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components';
import useGlobal from '../store';
import Logo from './ui/SVGs/Logo';

const FooterStyled = styled.footer`
    width: 100%;
    padding-bottom: 45px;
    background-color: ${(props) => props.theme.colors.backgrounds.sand};
    font-size: 0.7rem;
    box-sizing: border-box;

    & .footer__container {
        width: 100%;
        max-width: 1316px;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .footer__logo {
        margin-top: 40px;
        margin-bottom: 28px;
        order: 1;
    }

    .footer__contact__container {
        order: 2;
    }

    .footer__contact {
        border: 1px solid #aaaaaa;
        box-sizing: border-box;
        height: 50px;
        width: 309px;
        color: #4a4f53;
        font: 0.875rem ${(props) => props.theme.fonts[0]}, sans-serif;
        letter-spacing: 0;
        line-height: 1.5rem;
        text-align: center;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        text-decoration: none;

        &:hover {
            color: ${(props) => props.theme.colors.buttons.primary};
        }
        @media screen and (max-width: 360px) {
            width: 280px;
        }
    }

    .footer__link__container {
        height: 205px;
        width: 118px;
        display: table;
        table-layout: auto;
        margin-top: 32px;
        order: 3;
    }

    .footer__link {
        display: table-row;
        color: #404041;
        font-family: ${(props) => props.theme.fonts[0]}, sans-serif;
        font-size: 12px;
        font-weight: bold;
        letter-spacing: 2.24px;
        line-height: 15px;
        text-align: center;
        text-decoration: none;
    }

    .footer__legal {
        height: 24px;
        width: 275px;
        color: #909090;
        font-family: ${(props) => props.theme.fonts[0]}, sans-serif;
        font-size: 12px;
        letter-spacing: 0;
        line-height: 24px;
        order: 4;
    }

    .vertical__line {
        height: 70px;
        border-left: 1px #aaaaaa;
        border-left-style: solid;
        margin-left: 90px;
        margin-right: 39px;
        display: none;
    }

    @media screen and (min-width: 1024px) {
        .footer__container {
            flex-direction: row;
            justify-content: center;
            flex-wrap: wrap;
            padding: 1rem;
        }

        .footer__logo {
            order: 1;
            margin-top: 39px;
            margin-bottom: 18px;
        }

        .footer__contact__container {
            margin-left: auto;
            margin-right: 0px;
            order: 4;
        }

        .footer__contact {
            width: 168px;
            display: inline-flex;
        }

        .footer__link__container {
            display: flex;
            justify-content: right;
            align-items: center;
            order: 3;
            width: 552px;
            height: 100px;
            margin: 0px 0px 0px 0px;
        }

        .footer__link {
            display: table-cell;
            vertical-align: middle;
            /* width: 110px; */
            margin-right: 60px;
        }

        .footer__legal {
            flex: 0 0 99%;
            order: 5;
            width: 90%;
            text-align: right;
        }

        .vertical__line {
            display: flex;
            order: 2;
        }
    }

    .footer__copy {
        text-align: center;
    }

    .copyright {
        color: #fff;
        line-height: 1rem;
        text-align: center;

        @media screen and (min-width: 1160px) {
            &:nth-of-type(1) {
                margin-right: 4px;
            }
        }
    }
`;

const Footer = () => {
    const footerItemClicked = (buttonName) => {
        window.dataLayer.push({
            event: `${buttonName} Button Clicked`,
            pagePath: '',
            pageTitle: '',
        });
    };

    const [globalState, globalActions] = useGlobal();
    const { status, footerData } = globalState;

    const defaultSection = {
        footer_logo: {},
        link: [],
        email: {},
        phone_number: {},
    };

    const {
        footer: {
            email: email,
            phone_number: phone_number,
            footer_logo: footer_logo,
            link: link,
        } = defaultSection,
    } = globalState;

    const footerLogoDetail = footer_logo?.logo?.file;
    const cpText = footer_logo?.logo?.custom_data;

    return (
        <FooterStyled className="footer">
            <section className="footer__container">
                <Logo
                    className="footer__logo"
                    logoGreenAmerica={footerLogoDetail}
                />
                <div className="vertical__line" />
                <div className="footer__contact__container">
                    <a
                        href={`tel:${phone_number?.href}`}
                        className="footer__contact"
                    >
                        {phone_number?.title}
                    </a>
                    <a
                        href={`mailto:${email?.href}`}
                        className="footer__contact"
                    >
                        {email?.title}
                    </a>
                </div>
                <div className="footer__link__container">
                    {link &&
                        link.map((content) => {
                            // if (content.title !== 'CORN BIDS') {
                                return (
                                    <Link
                                        to={content?.href}
                                        onClick={() =>
                                            footerItemClicked(content?.title)
                                        }
                                        className="footer__link"
                                    >
                                        {content?.title}
                                    </Link>
                                );
                            // }
                        })}
                </div>
                <span className="footer__legal">
                    &copy; {new Date().getFullYear()} {cpText}
                </span>
            </section>
        </FooterStyled>
    );
};

export default Footer;
